// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"54fca18e","1":"98017f3b","17":"ff748217","30":"1fa59fd4","174":"8c54320e","275":"a140529f","377":"fa51585c","591":"38017b6c","648":"b163e15b","654":"ebdcd2bd","662":"463045d0","739":"10d3c1c8","880":"f14bd56d"}[chunkId] + ".chunk.js";
};